import React, { useState, useEffect } from "react";
import logo from "./img/gap.png";
import LogNav from "./Nav2";
import { useNavigate } from "react-router-dom";
import bcrypt from "bcryptjs";
import "./login.css";

const accessData = [
  {
    username: "1ADMIN6965",
    password: bcrypt.hashSync("6880", 10),
    redirectPath: "/admin",
  },
  {
    username: "1ADMIN85",
    password: bcrypt.hashSync("658072", 10),
    redirectPath: "/adminDPHU",
  },
  {
    username: "1ADMIN7365",
    password: bcrypt.hashSync("7583", 10),
    redirectPath: "/adminKISA",
  },
  {
    username: "1ADMIN7177",
    password: bcrypt.hashSync("7965", 10),
    redirectPath: "/adminGOMA",
  },
  {
    username: "1ADMIN8573",
    password: bcrypt.hashSync("7875", 10),
    redirectPath: "/adminUNIKAL",
  },
  {
    username: "1ADMIN8569",
    password: bcrypt.hashSync("7857", 10),
    redirectPath: "/adminMUKEDI",
  },
  {
    username: "1ADMIN8579",
    password: bcrypt.hashSync("7877", 10),
    redirectPath: "/adminUNIM",
  },
  {
    username: "1ADMIN696D",
    password: bcrypt.hashSync("6977", 10),
    redirectPath: "/adminISTAM",
  },
  {
    username: "1ADMIN706D",
    password: bcrypt.hashSync("7077", 10),
    redirectPath: "/adminUND",
  },
  {
    username: "1ADMIN536D",
    password: bcrypt.hashSync("536D", 10),
    redirectPath: "/adminUNCR",
  },
  {
    username: "CIERHA4539",
    password: bcrypt.hashSync("0CH593AD", 10),
    redirectPath: "/adminCIERHA",
  },
  {
    username: "0ADMIN0",
    password: bcrypt.hashSync("super@password", 10),
    redirectPath: "/superadmin",
  },
];

function Login() {

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Login STU-Pack";
    return () => {
      document.title = previousTitle;
    };
  }, []);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ id: "", pass: "" });
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [id]: value }));
  };

  const MAX_STORAGE_SIZE = 5000;

const checkStorageUsage = () => {
  let totalSize = 0;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    const value = localStorage.getItem(key);
    totalSize += key.length + value.length;
  }
  return totalSize;
};

const removeOldEntries = () => {
  const keys = [];
  for (let i = 0; i < localStorage.length; i++) {
    keys.push(localStorage.key(i));
  }
  keys.sort();
  while (checkStorageUsage() > MAX_STORAGE_SIZE && keys.length > 0) {
    const oldestKey = keys.shift();
    localStorage.removeItem(oldestKey);
  }
};

const storeData = (key, data) => {
  removeOldEntries();
  localStorage.setItem(key, JSON.stringify(data));
};

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = accessData.find((user) => user.username === formData.id);
    const data = {
      username: "exampleUser",
      role: "admin",
    };

    if (user && bcrypt.compareSync(formData.pass, user.password)) {
      localStorage.setItem('userRole', user.redirectPath);
      navigate(user.redirectPath);
    } else {
      setErrorMessage("Invalid username or password");
    }
    storeData('userData', data);
  };

  return (
    <div className="plogin">
      <LogNav />
      <div className="page">
        <div className="form-container">
          <img src={logo} className="form-logo" alt="Logo" />
          <h2>Connectez-vous</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              id="id"
              className="inbox"
              placeholder="Identifiant / Matricule"
              value={formData.id}
              onChange={handleChange}
              required
            />
            <input
              type="password"
              id="pass"
              className="inbox"
              placeholder="Mot de passe"
              value={formData.pass}
              onChange={handleChange}
              required
            />
            <a className="forgot" href="#">
              Mot de passe oublié ?
            </a>
            <button type="submit" id="sub-btn" className="form-button">
              Se connecter
            </button>
          </form>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
      </div>
      <footer><br/>G.A.P © All Rights Reserved 2024.<br/><br/> </footer>
    </div>
  );
}

export default Login;